import { UPDATE_CART } from '../actions/types';

const initialState = { cartItems : [] };

export default (state = initialState, action)=>{
    switch(action.type){
        case UPDATE_CART : {
            return { ...state, cartItems : action.payload}
        }
        default : {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/v3/reducers/cartReducer.js